// extracted by mini-css-extract-plugin
module.exports = {"sensorName":"SensorHeader_sensorName__3n7Fx"};